import React, { useCallback, useMemo } from 'react';
import { useRouter } from 'next/navigation';
import { AUTOCOMPLETE_PRODUCT_CLICKED } from 'helpers/constants/events';
import Link from '../../link';
import Image from 'frontastic/lib/image';

interface Props {
  hit: any;
  onClick?: () => void;
}

const ContentSearchItem: React.FC<Props> = ({ hit, onClick }) => {
  const router = useRouter();

  // const discountedVariant = useVariantWithDiscount(hit.variants as Partial<Variant>[]);

  const handleClick = useCallback(() => {
    onClick?.();

    router.push(hit._url ?? '#');
  }, [hit, onClick, router]);
  return (
    <>
      <Link link={hit?.url}>
        <div className="flex items-center gap-12 hover:bg-[#eee]" onClick={handleClick}>
          <div className="shrink-0 p-5 3xl:p-8">
            <div className="relative h-70 w-70 lg:h-40 lg:w-40 3xl:h-70 3xl:w-70">
              <Image
                src={encodeURI(hit?.seo?.meta_image?.url ?? '/images/no-image-placeholder/product-thumbnail.jpg')}
                fill
                style={{ objectFit: 'contain' }}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                onError={(event: any) => {
                  event.target.id = '/images/no-image-placeholder/product-thumbnail.jpg';
                  event.target.srcset = '/images/no-image-placeholder/product-thumbnail.jpg';
                }}
              />
            </div>
          </div>
          <div>
            <div className="flex flex-col gap-4">
              <span className="text-16 font-medium capitalize text-[#333] lg:text-12 3xl:text-16">
                {hit?.seo?.meta_title.replace('Caroma Made For Life |', '')}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default ContentSearchItem;
